import React from 'react';

import { BBoxCorner } from './BBoxCorner';
import { Character } from './types';

export interface BBoxProps {
  characterId: Character['id'];
  scalingCallback: (
    newX: number | null,
    newY: number | null,
    newWidth: number | null,
    newHeight: number | null
  ) => void;
  scaleStartCallback: () => void;
  scaleEndCallback: () => void;
}

export const BBox: React.FC<BBoxProps> = ({
  characterId,
  scalingCallback,
  scaleStartCallback,
  scaleEndCallback,
}) => {
  return (
    <g>
      <rect x={0} y={0} height="100%" width="100%" fill="none" stroke="black" />

      <BBoxCorner
        characterId={characterId}
        cornerPosition="top-left"
        cx={0}
        cy={0}
        scaleStartCallback={scaleStartCallback}
        scalingCallback={scalingCallback}
        scaleEndCallback={scaleEndCallback}
      />

      <BBoxCorner
        characterId={characterId}
        cornerPosition="top-right"
        cx="100%"
        cy={0}
        scaleStartCallback={scaleStartCallback}
        scalingCallback={scalingCallback}
        scaleEndCallback={scaleEndCallback}
      />

      <BBoxCorner
        characterId={characterId}
        cornerPosition="bottom-left"
        cx={0}
        cy="100%"
        scaleStartCallback={scaleStartCallback}
        scalingCallback={scalingCallback}
        scaleEndCallback={scaleEndCallback}
      />

      <BBoxCorner
        characterId={characterId}
        cornerPosition="bottom-right"
        cx="100%"
        cy="100%"
        scaleStartCallback={scaleStartCallback}
        scalingCallback={scalingCallback}
        scaleEndCallback={scaleEndCallback}
      />
    </g>
  );
};
